import { defineMessages } from 'react-intl';

export const scope = 'app.components.ManageMembers';

export const messages = defineMessages({
  buttonRevokeAccess: {
    id: `${scope}.buttonRevokeAccess`,
    defaultMessage: 'Revoke Access',
  },
  errRolesNotSaved: {
    id: `${scope}.errRolesNotSaved`,
    defaultMessage: "The permission change wasn't saved. Please try again.",
  },
  errRolesRefused: {
    id: `${scope}.errRolesRefused`,
    defaultMessage: "The permission change wasn't saved: {reason}",
  },
});
